module.exports = __webpack_public_path__ + "static/media/school_v.73828aac.mp4";